import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-update-offer',
  templateUrl: './update-offer.component.html',
  styleUrls: ['./update-offer.component.scss']
})
export class UpdateOfferComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, 
    private active: ActivatedRoute, 
    private config: ApiConfiguration, 
    private service: ApiService,
    private toast: ToastClientService) { 
      this.AddOffer = this.formBuilder.group({
        id: ['', [Validators.required]],
        offer_name: ['', [Validators.required]],
        offer_description:['', [Validators.required]],
        offer_start_date:['', [Validators.required]],
        offer_end_date:['', [Validators.required]],
        offer_type:['', [Validators.required]],
        offer_image:['', []],
        
      });
    }

  public offerId;
  public AddOffer: FormGroup;
  public productImage;
  public thumbnail;
  ngOnInit() {
    this.active.queryParams.subscribe((res:any)=>{
      console.log(res)
      this.offerId = res.offerId;
      this.service.get(this.config.getOfferById+'offer_id='+this.offerId)
      .subscribe((res:any)=>{
        console.log(res)
        this.AddOffer.controls['id'].setValue(res.data.offer_data.id);
        this.AddOffer.controls['offer_name'].setValue(res.data.offer_data.offer_name);
        this.AddOffer.controls['offer_description'].setValue(res.data.offer_data.offer_description);
        this.thumbnail  = res.data.offer_data.offer_image;
        this.AddOffer.controls['offer_start_date'].setValue((res.data.offer_data.offer_start_date).split(" ")[0]);
        this.AddOffer.controls['offer_end_date'].setValue((res.data.offer_data.offer_end_date).split(" ")[0]);
        this.AddOffer.controls['offer_type'].setValue(res.data.offer_data.offer_type);
        
      })
    })
  }
  imageChange(img){
    console.log(img)
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function() {
      //self.AddOffer.controls['offer_image'].setValue(reader.result);
      self.AddOffer.value.offer_image = reader.result;
      self.productImage = reader.result;
    }
      reader.readAsDataURL(file);
  
    }

  submit(){
    let payload = this.AddOffer.value;
    if(this.AddOffer.value.offer_image == ""){
      delete payload.offer_image;
    }
    payload.program_id = 1;
    
    this.service.postWithFormData(this.config.updateOffer, payload)
    .subscribe((res:any)=>{
      if(res.status == 200){
        this.toast.Success("Updates Successfully");
        this.ngOnInit()
      }else{
        console.log(res)
      }
    })
    
  }

}
